import { motion } from "framer-motion";
import { POLICIES, POLICIES_UPDATED } from "@/data/policies";

export default function PoliciesPage() {
  return (
    <main className="min-h-screen vector-grid pt-28 pb-24" data-testid="policies-page">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="eyebrow">Business Aligned</span>
          <h1 className="f-display text-4xl sm:text-5xl tracking-tight mt-4 leading-[1.05]">Terms & <span className="f-serif text-[#A8785A]">Policies</span></h1>
          <p className="f-mono text-[11px] text-[#8C7562] mt-4">LAST UPDATED · {POLICIES_UPDATED.toUpperCase()}</p>
        </motion.div>

        <nav className="flex flex-wrap gap-2 mt-10" data-testid="policies-nav">
          {POLICIES.map((p) => (
            <a key={p.id} href={`#${p.id}`} className="text-[11px] font-semibold border border-[#E8DCCB] bg-[#FFFDF7] rounded-full px-3.5 py-1.5 text-[#8C7562] hover:border-[#A8785A] hover:text-[#A8785A] transition-colors">
              {p.title}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-6 mt-10">
          {POLICIES.map((p, i) => (
            <motion.section key={p.id} id={p.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5 }} className="glass rounded-2xl p-7 sm:p-10 scroll-mt-28" data-testid={`policy-${p.id}`}>
              <span className="f-mono text-[11px] text-[#A8785A]">0{i + 1}</span>
              <h2 className="f-display text-2xl sm:text-3xl tracking-tight mt-2 mb-5">{p.title}</h2>
              <div className="flex flex-col gap-4">
                {p.paragraphs.map((t, j) => <p key={j} className="text-[15px] text-[#57473B] leading-relaxed">{t}</p>)}
              </div>
            </motion.section>
          ))}
        </div>
      </div>
    </main>
  );
}
